// import axios from 'axios'
import { LOGIN } from './skanRateCardStoreActionTypes';
export const loginUser = (data) => {
  //console.log('logincalled', data);
  return {
    type: LOGIN,
    payload: data
  };
};
